<template>
  <div>
    <div class="mc-sidebar-route__action">
      <McButton
        variant="secondary"
        class="mx-2"
        icon="mc-fa icon-fill_close"
        :text="$t('global.cancel')"
        @click="handleCancel"
      />
      <b-dropdown v-if="!isAdding" variant="outline-primary">
        <template #button-content>
          {{ $t('global.action.changeStatus') }}
          <i class="mdi mdi-chevron-down"></i>
        </template>
        <b-dropdown-item v-if="status == 'A'" @click="showUpdateStatus('I')">
          {{ $t('master.status.aktif') }}
        </b-dropdown-item>
        <b-dropdown-item v-if="status == 'I'" @click="showUpdateStatus('A')">
          {{ $t('master.status.arsip') }}
        </b-dropdown-item>
      </b-dropdown>
      <McButton
        variant="primary"
        :class="!isAdding ? 'mx-2' : ''"
        :disabled="isSubmit"
        icon="icon-outline_save"
        :text="$t('global.save')"
        @click="handleSubmit"
      />
    </div>
    <b-sidebar
      id="sidebar"
      no-header
      no-header-close
      no-close-on-backdrop
      no-close-on-esc
      no-close-on-route-change
      class="mc-sidebar-liveview mc-sidebar-route"
    >
      <div class="mc-sidebar-liveview__wrapper">
        <div class="mc-sidebar-route__wrapper" :class="{ autostart: isAutoStart }">
          <FormulateForm
            ref="formRef"
            v-model="formValues"
            name="route-form"
            @submit="handleSubmit"
          >
            <h4 class="mc-sidebar-route__title">
              {{ $t('route.routeInformation') }}
            </h4>
            <FormulateInput
              type="text"
              name="name"
              :label="$t('master.list.route.routeName')"
              :placeholder="$t('master.list.route.routeName')"
              validation="required"
              help="required"
            />

            <div class="mt-2">
              <McToggle
                v-model="isAutoStart"
                :label="$t('master.list.route.isAutoStart')"
                placement="left"
                :disabled="isDisabledAutoStart"
              />
            </div>

            <div v-if="isAutoStart">
              <McAlert
                withIcon
                variant="info"
                iconVariant="fill"
                iconPosition="center"
                help="required"
                :hasClose="false"
                :text="$t('master.list.route.exitGeofence')"
              />
              <FormulateInput
                id="originLocation"
                ref="origin-location-ref"
                v-model="originLocation"
                :disabled="isDisabledOriginLocation"
                name="originLocation"
                class="mt-2"
                :label="$t('global.object.originLocation')"
                :placeholder="$t('global.form.select') + ' ' + $t('global.object.originLocation')"
                :tableFields="tableFieldsOriginLocation"
                trackBy="id"
                displayedBy="name"
                :listGetter="routeOptions"
                :multiple="false"
                type="value-help-v2"
                validation="required"
                help="required"
                :fullObject="fullObject.originLocation"
                @update:value="$emit('update:value', $event)"
                @update:fullObject="$emit('update:fullObject', $event)"
              />
              <FormulateInput
                id="licensePlate"
                ref="license-plate-ref"
                v-model="vehicleId"
                :disabled="isDisabledLicensePlate"
                name="licensePlate"
                class="mt-2"
                :label="$t('global.object.licensePlate')"
                :placeholder="$t('global.form.select') + ' ' + $t('global.object.licensePlate')"
                :tableFields="tableFieldsVehicle"
                trackBy="id"
                displayedBy="license_plate"
                :listGetter="vehicleOptions"
                :multiple="true"
                :canSelectAll="true"
                :fullObject="fullObject.vehicle"
                type="route-value-help"
                validation="required"
                help="required"
              />
            </div>

            <h4 class="mc-sidebar-route__title mt-2">
              {{ $t('route.routeOrder') }}
              <span id="routeOrder" class="mc-input-info__btn">
                <i class="mc-fa icon-outline_info"></i>
              </span>
              <b-tooltip target="routeOrder" triggers="hover" placement="lefttop">
                {{ $t('route.tooltipAlternativeRoute') }}
              </b-tooltip>
            </h4>
            <b-tabs class="mc-sidebar-liveview__fleet-filter">
              <b-tab active>
                <template #title>
                  <McButton
                    icon="mc-fa icon-outline_pin-history"
                    :text="$t('master.list.route.routePrimary')"
                    variant="secondary"
                    size="sm"
                    block
                  />
                </template>
                <div class="mc-sidebar-route__list">
                  <div class="mc-sidebar-route__list--wrapper">
                    <FormulateInput
                      type="group"
                      name="primary"
                      :add-label="$t('route.addPoint')"
                      repeatable
                      remove-position="after"
                      :minimum="0"
                      :limit="29"
                      :disabled="isOSRMPending"
                      @input="setStart"
                      @repeatableRemoved="handleRemove('geofence')"
                    >
                      <template #default="{ index }">
                        <div class="mc-sidebar-route__list-item clearfix">
                          <span>{{ index + 1 }}</span>
                          <FormulateInput
                            type="select-resourceful"
                            name="geofence"
                            :placeholder="`${$t('global.form.select')} ${$t('route.locationName')}`"
                            :optionsGetter="routeOptionsPrimary"
                            :initialObject="primaryObj?.[index]"
                            :optionLabelFn="
                              ({ item }) => {
                                return item.name
                              }
                            "
                            validation="required"
                            error-behavior="live"
                            :disabled="isOSRMPending || (isAutoStart && index === 0)"
                            @input="generateRoute"
                          />
                        </div>
                      </template>
                      <template #remove="{ removeItem, index }">
                        <i
                          class="mc-fa icon-outline_trash"
                          :class="
                            totalField < 3 || isOSRMPending || (isAutoStart && index === 0)
                              ? 'd-none'
                              : 'd-block'
                          "
                          @click="removeItem"
                        ></i>
                      </template>
                    </FormulateInput>
                    <div
                      class="mc-sidebar-route__list-item mc-sidebar-route__list-item--last clearfix clearfix"
                    >
                      <span>
                        <i class="mc-fa icon-outline_pin"></i>
                      </span>
                      <FormulateInput
                        type="select-resourceful"
                        name="geofence2"
                        :placeholder="`${$t('global.form.select')} ${$t('route.locationName')}`"
                        :optionsGetter="routeOptions"
                        :initialObject="showResponse?.route_plan?.[0].geofences?.[primaryTotal - 1]"
                        :optionLabelFn="
                          ({ item }) => {
                            return item.name
                          }
                        "
                        validation="required"
                        error-behavior="live"
                        :disabled="isOSRMPending"
                        @input="setStop"
                      />
                    </div>
                  </div>
                </div>
                <b-alert
                  v-if="primaryAlert"
                  show
                  variant="primary"
                  class="mc-sidebar-route__list-item-notif"
                >
                  <div class="d-flex justify-content-between">
                    <div>
                      <span class="text-muted">{{ $t('global.object.tripTime') }}</span>
                      <h4>{{ routeDesc.primaryETA }}</h4>
                    </div>
                    <div>
                      <span class="text-muted">{{ $t('global.object.mileage') }}</span>
                      <h4>{{ routeDesc.primaryDistance }} Km</h4>
                    </div>
                  </div>
                </b-alert>
              </b-tab>
              <b-tab>
                <template #title>
                  <McButton
                    icon="mc-fa icon-outline_pin-history"
                    :text="$t('master.list.route.routeAlternative')"
                    variant="secondary"
                    size="sm"
                    block
                  />
                </template>
                <div class="mc-sidebar-route__list">
                  <div class="mc-sidebar-route__list--wrapper">
                    <div class="mc-sidebar-route__list-item clearfix">
                      <span>1</span>
                      <multiselect
                        v-model="alternate.start"
                        :placeholder="`${$t('global.form.select')} ${$t('route.locationName')}`"
                        track-by="id"
                        label="name"
                        :options="optionsAddress"
                        disabled
                      />
                    </div>
                    <FormulateInput
                      type="group"
                      name="alternate"
                      :add-label="$t('route.addPoint')"
                      repeatable
                      remove-position="after"
                      :limit="8"
                      :disabled="isOSRMPending"
                      @input="generateRoute"
                      @repeatableRemoved="handleRemove('altgeofence')"
                    >
                      <template #default="{ index }">
                        <div class="mc-sidebar-route__list-item clearfix">
                          <span>{{ index + 2 }}</span>
                          <FormulateInput
                            type="select-resourceful"
                            name="geofence"
                            :placeholder="`${$t('global.form.select')} ${$t('route.locationName')}`"
                            :optionsGetter="routeOptions"
                            :initialObject="alternateObj ? alternateObj?.[index] : undefined"
                            :optionLabelFn="
                              ({ item }) => {
                                return item.name
                              }
                            "
                            :disabled="isOSRMPending"
                            @input="generateRoute"
                          />
                        </div>
                      </template>
                      <template #remove="{ removeItem }">
                        <i class="mc-fa icon-outline_trash" @click="removeItem"></i>
                      </template>
                    </FormulateInput>
                    <div
                      class="mc-sidebar-route__list-item mc-sidebar-route__list-item--last clearfix clearfix"
                    >
                      <span>
                        <i class="mc-fa icon-outline_pin"></i>
                      </span>
                      <multiselect
                        v-model="alternate.stop"
                        :placeholder="`${$t('global.form.select')} ${$t('route.locationName')}`"
                        track-by="id"
                        label="name"
                        :options="optionsAddress"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <b-alert
                  v-if="altAlert"
                  show
                  variant="primary"
                  class="mc-sidebar-route__list-item-notif"
                >
                  <div class="d-flex justify-content-between">
                    <div>
                      <span class="text-muted">{{ $t('global.object.tripTime') }}</span>
                      <h4>{{ routeDesc.alternateETA }}</h4>
                    </div>
                    <div>
                      <span class="text-muted">{{ $t('global.object.mileage') }}</span>
                      <h4>{{ routeDesc.alternateDistance }} Km</h4>
                    </div>
                  </div>
                </b-alert>
              </b-tab>
            </b-tabs>
          </FormulateForm>
        </div>
      </div>
    </b-sidebar>
    <b-modal
      id="mc-modal-update"
      ref="mc-modal-update"
      class="mc-modal"
      :title="$t('global.action.changeStatus')"
      body-class="p-3"
      size="md"
      centered
    >
      <div class="card-body mc-modal__filter p-2">
        <p>
          {{ $t('global.text.modal.changeStatus2') }}
          <b v-if="updateStatus === 'I'">{{ $t('master.status.aktif') }}</b>
          <b v-if="updateStatus === 'A'">{{ $t('master.status.arsip') }}</b> ?
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton
              :text="$t('global.action.cancel')"
              variant="secondary"
              class="me-2"
              @click="cancel()"
            />
            <McButton
              :text="$t('global.action.update')"
              variant="primary"
              @click="handleUpdateStatus"
            />
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal
      id="mc-modal-origin-location"
      ref="mc-modal-origin-location"
      class="mc-modal"
      :title="$t('global.change') + ' ' + $t('global.object.originLocation')"
      body-class="p-3"
      size="md"
      centered
    >
      <div class="card-body mc-modal__filter p-2">
        <p class="mc-paragraph">
          {{ $t('global.text.modal.changeOriginLocation') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton
              :text="$t('global.action.cancel')"
              variant="secondary"
              class="me-2"
              @click="cancel()"
            />
            <McButton
              :text="$t('global.action.apply')"
              variant="primary"
              @click="handleConfirmOriginLocation"
            />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import responsive from '@/mixin/responsive'
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import * as addressApi from '@/services/rest-api-vsms/lib/route/address'
import * as routeApi from '@/services/rest-api-vsms/lib/route/route'
import Multiselect from 'vue-multiselect'
import McToggle from '@/components/McToggle'
import McAlert from '@/components/McAlert'

export default {
  name: 'SideBar',
  components: { Multiselect, McButton, McToggle, McAlert },
  mixins: [responsive, Helper, MixPanel],
  data() {
    return {
      primaryRoute: [],
      altRoute: [],
      formValues: {
        fleetType: null,
        fleetCategory: null,
      },
      totalAddress: 10,
      routeOptions: addressApi.get,
      routeOptionsPrimary: (opts) => {
        return addressApi.get({ ...opts, limit: this.totalAddress })
      },
      vehicleOptions: null,
      optionsAddress: [],
      optionsVehicle: [],
      routeDesc: {
        primaryDistance: '',
        primaryETA: '',
        alternateDistance: '',
        alternateETA: '',
      },
      showResponse: {},
      primaryTotal: null,
      altTotal: null,
      status: null,
      primaryAlert: false,
      altAlert: false,
      marker: {
        primary: [],
        alternate: [],
      },
      alternate: {
        start: null,
        stop: null,
      },
      primaryObj: [],
      alternateObj: [],
      updateStatus: null,
      isSubmit: false,
      totalField: 0,
      isOSRMPending: false,
      isAutoStart: false,
      fullObject: {
        originLocation: [],
        vehicle: [],
      },
      originLocation: null,
      vehicleId: null,
      disabledLicensePlate: true,
      isDisabledOriginLocation: false,
      isDisabledAutoStart: false,
      routeDurations: {
        primary: null,
        alternate: null,
      },
      generateRouteCallCount: 0,
      maxGenerateRouteCalls: 1,
      isInitialLoad: true,
    }
  },
  computed: {
    google: gmapApi,
    isAdding() {
      return typeof this.$route.params.id === 'undefined'
    },
    routeId() {
      return parseInt(this.$route.params.id)
    },
    hasAltInput() {
      return {
        required: this.formValues.altgeofence0,
      }
    },
    tableFieldsOriginLocation() {
      return [
        {
          label: this.$t('global.object.locationName'),
          key: 'name',
          isSortable: false,
        },
        {
          label: this.$t('master.form.address.fullAddress'),
          key: 'full_name',
          isSortable: false,
        },
      ]
    },
    tableFieldsVehicle() {
      return [
        {
          label: this.$t('fleetTask.fields.licensePlate'),
          key: 'license_plate',
          isSortable: false,
        },
        {
          label: this.$t('fleetTask.fields.vehicleType'),
          key: 'type.name',
          isSortable: false,
        },
        {
          label: this.$t('global.object.fleetGroup'),
          key: 'v_groups',
          isSortable: false,
          formatter: (value) => {
            return value?.map((group) => group.name)?.join(', ') || '-'
          },
        },
      ]
    },
    isDisabledLicensePlate() {
      return !this.originLocation
    },
  },

  watch: {
    originLocation: {
      handler(newVal, oldVal) {
        if (newVal && oldVal && this.isAutoStart) {
          this.vehicleOptions = (opts) =>
            routeApi.getVehicle({
              origin_address_id: Number(newVal),
              ...opts,
            })

          // Show the modal
          this.$bvModal.show('mc-modal-origin-location')
        } else if (newVal) {
          const originLocationId = Number(newVal)
          this.fullObject.originLocation = this.optionsAddress.find(
            (obj) => obj.id === originLocationId
          )

          if (this.isAdding) {
            this.primaryObj = [this.optionsAddress.find((obj) => obj.id === originLocationId)]
          }

          if (!this.formValues.primary) {
            this.formValues.primary = [{ geofence: originLocationId }]
          } else {
            this.$set(this.formValues.primary, 0, { geofence: originLocationId })
          }

          this.vehicleOptions = (opts) =>
            routeApi.getVehicle({
              origin_address_id: Number(newVal),
              ...opts,
            })

          this.setStart()
        }
      },
      immediate: true,
    },
    vehicleId: {
      handler(newVal) {
        if (newVal) {
          const vehicleIds = newVal.map((id) => Number(id))
          this.fullObject.vehicle = this.optionsVehicle.filter((vehicle) =>
            vehicleIds.includes(vehicle.id)
          )
        }
      },
      immediate: true,
    },
    'formValues.primary': {
      handler(newVal) {
        if (!this.isAutoStart && newVal?.[0]?.geofence) {
          this.originLocation = newVal?.[0]?.geofence
        }
        this.alternate.start = this.optionsAddress.find((obj) => obj.id === newVal?.[0]?.geofence)
      },
      deep: true,
    },
    '$i18n.locale': {
      handler() {
        if (this.formValues.primary || this.formValues.alternate) {
          this.updateTimeTranslations()
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    await this.getAddress()
    await this.getVehicle()
    if (!this.isAdding) {
      this.track('View Detail Route')
      await this.showData()
      await this.showDirection()
      setTimeout(() => {
        this.isInitialLoad = false
        this.generateRouteCallCount = 0
      }, 1000)
    }
  },
  methods: {
    async showData(id = null) {
      const fetchedData = await routeApi.show(this.routeId ?? id)
      if (!fetchedData?.data) return
      const data = fetchedData.data ?? {}
      const parsedData = this.parseRouteData(data)
      this.showResponse = data
      const convertToGeofence = (geofence) =>
        geofence.map((item) => {
          const centerpoint =
            item.type === 'P'
              ? this.getCenterpoint(item.geolocation)
              : { lat: item.geolocation[0][0], long: item.geolocation[0][1] }
          return { id: item.id, ...centerpoint }
        })
      this.primaryTotal = data.route_plan[0]?.geofences.length
      this.altTotal = data.route_plan[1]?.geofences.length
      this.primaryObj = data.route_plan[0]?.geofences.slice(0, this.primaryTotal - 1)
      let altGeofence = null
      if (this.altTotal) {
        altGeofence = this.convertGeolocationStringToArray(data.route_plan[1]?.geofences)
        this.marker.alternate = convertToGeofence(altGeofence)
        this.altAlert = true
        this.alternateObj = data.route_plan[1]?.geofences.slice(1, this.altTotal - 1)
      }
      //create marker for update
      const primaryGeofence = this.convertGeolocationStringToArray(data.route_plan[0]?.geofences)

      this.marker.primary = convertToGeofence(primaryGeofence)

      const isAnotherGroup = data.contains_unrelated_vehicles ?? false
      this.isDisabledAutoStart = data.contains_unrelated_vehicles ?? false
      if (isAnotherGroup) {
        this.optionsVehicle.unshift({
          id: 0,
          license_plate: this.$t('global.object.anotherGroup'),
        })
        data.route_vehicle_ids.unshift(0)
        this.isDisabledOriginLocation = true
      }
      this.isAutoStart = data?.route_vehicle_ids?.length > 0 ? true : false
      this.originLocation = data.route_plan[0]?.geofences.slice(0, this.primaryTotal - 1)[0].id
      this.vehicleId = data.route_vehicle_ids

      this.status = data.status
      this.formValues = { ...parsedData }
      this.primaryAlert = true
      this.routeDesc = {
        primaryDistance: data.route_plan[0].distance_label,
        primaryETA: data.route_plan[0].eta_time_label,
        alternateDistance: data?.route_plan?.[1]?.distance_label,
        alternateETA: data?.route_plan?.[1]?.eta_time_label,
      }
    },
    async showDirection(id = null) {
      const res = await routeApi.showDirection(this.routeId ?? id)
      if (!res?.data) return
      const primaryDirection = JSON.parse(res?.data.route_plan?.[0].geometry)
      let altDirection = null
      let altLine = []
      const primaryLine = primaryDirection.map(([long, lat]) => ({
        long,
        lat,
      }))
      if (this.altTotal) {
        altDirection = JSON.parse(res?.data.route_plan?.[1].geometry)
        altLine = altDirection.map(([long, lat]) => ({
          long,
          lat,
        }))
        this.$root.$emit('polyLine', altLine, 1, this.marker.alternate)
      }
      this.$root.$emit('polyLine', primaryLine, 0, this.marker.primary)
    },
    parseRouteData(data) {
      const newData = { ...data }
      const geofenceIndex = newData.route_plan[0].geofences.length - 1
      const primary = []
      const alternate = []
      for (let i = 0; i <= data.route_plan[0].geofences.length - 2; i++) {
        primary.push({ geofence: data.route_plan[0].geofences[i].id })
      }
      if (data.route_plan?.[1]?.geofences.length > 2) {
        for (let i = 1; i <= data.route_plan?.[1].geofences.length - 2; i++) {
          alternate.push({ geofence: data.route_plan[1].geofences[i].id })
        }
      }
      const newGeofence = {
        geofence2: newData.route_plan[0].geofences[geofenceIndex].id,
        altgeofence0: newData.route_plan[0].geofences[0].id,
        altgeofence2: newData.route_plan[0].geofences[geofenceIndex].id,
        primary: [...primary],
        alternate: alternate.length > 0 ? [...alternate] : undefined,
      }

      const parsedData = {
        name: data.name,
        ...newGeofence,
      }
      return parsedData
    },
    async getAddress() {
      const res = await addressApi.get({ limit: 5, page: 1 })
      const total = res.metadata.total_count
      this.totalAddress = total

      const address = await addressApi.get({ limit: total, page: 1 })
      this.optionsAddress = address.data.paginated_result
    },
    convertGeolocationStringToArray(locations) {
      const modifiedLocations = locations.map((location) => {
        let geolocationString = null
        if (location.geolocation) {
          geolocationString = location.geolocation
        } else if (location.coordinates) {
          geolocationString = location.coordinates
        }

        const coordinatesMatch = geolocationString.match(/\((-?\d+\.\d+,-?\d+\.\d+)\)/g)

        if (coordinatesMatch) {
          const coordinatesArray = coordinatesMatch.map((match) => {
            const [latitude, longitude] = match.slice(1, -1).split(',').map(parseFloat)
            return [latitude, longitude]
          })

          return {
            ...location,
            geolocation: coordinatesArray,
          }
        } else {
          return {
            ...location,
            geolocation: [],
          }
        }
      })
      return modifiedLocations
    },
    getRouteCoords(keyPrefix) {
      const route = []
      // Inject last geofences
      route.push(this.formValues[`${keyPrefix}2`])

      let additional = []
      if (keyPrefix == 'geofence' && this.formValues.primary) {
        additional = this.formValues.primary.map((item) => item.geofence)
      } else if (keyPrefix == 'altgeofence' && this.formValues.alternate) {
        additional = this.formValues.alternate.map((item) => item.geofence)
        // Inject first geofence
        additional.unshift(this.formValues[`${keyPrefix}0`])
      }
      additional = additional.filter((item) => item) //remove empty value
      route.unshift(...additional)

      const filteredRoute = route.map((id) => this.optionsAddress.find((obj) => obj.id === id))
      const convertedRoute = this.convertGeolocationStringToArray(filteredRoute)
      let geofence = []
      geofence = convertedRoute.map((item) => {
        const centerpoint =
          item.type === 'P'
            ? this.getCenterpoint(item.geolocation)
            : { lat: item.geolocation[0][0], long: item.geolocation[0][1] }
        return { id: item.id, ...centerpoint }
      })

      return geofence
    },
    getCenterpoint(latlong) {
      const coords = latlong.map(([lat, lng]) => ({
        lat: lat,
        lng: lng,
      }))
      let bounds = new this.google.maps.LatLngBounds()
      coords.forEach((element) => {
        bounds.extend(element)
      })
      const center = bounds.getCenter()
      return { lat: center.lat(), long: center.lng() }
    },
    async getDirection(params) {
      const geofences = this.getRouteCoords(params)
      if (geofences.length < 2) return

      this.isOSRMPending = true
      const points = geofences.map((item) => `${item.long},${item.lat}`)
      const payload = { points: points }
      const direction = await routeApi.generateRoutePost(payload)

      this.isOSRMPending = false
      if (!direction) return false

      return direction
    },
    setStart() {
      if (!this.isAdding && !this.isInitialLoad) {
        this.generateRouteCallCount = 0
      }
      this.alternate.start = this.optionsAddress.filter(
        (item) => item.id === this.formValues.primary[0].geofence
      )
      this.formValues.altgeofence0 = this.formValues.primary[0].geofence
      this.formValues.geofence0 = this.formValues.primary[0].geofence

      this.generateRoute()
    },
    setStop() {
      if (!this.isAdding && !this.isInitialLoad) {
        this.generateRouteCallCount = 0
      }
      this.alternate.stop = this.optionsAddress.filter(
        (item) => item.id === this.formValues.geofence2
      )
      this.formValues.altgeofence2 = this.formValues.geofence2

      this.generateRoute()
    },
    async generateRoute() {
      if (
        !this.isAdding &&
        this.isInitialLoad &&
        this.generateRouteCallCount >= this.maxGenerateRouteCalls
      ) {
        return
      }

      if (!this.isAdding && this.isInitialLoad) {
        this.generateRouteCallCount++
      }

      this.generateRouteCallCount++
      this.$root.$emit('resetPolyline')
      this.primaryAlert = false
      const primaryMarker = await this.getRouteCoords('geofence')
      this.totalField = primaryMarker.length
      const primaryGeofence = await this.getDirection('geofence')
      //create label
      if (primaryMarker.length > 1) this.primaryAlert = true
      //set primary line
      const [primaryHour, primaryMinutes, primarySeconds] = this.convertSectoHMS(
        primaryGeofence?.data?.routes[0].duration
      )
      this.routeDesc.primaryDistance = this.minimizeFloat(
        primaryGeofence?.data?.routes[0].distance / 1000
      )
      this.routeDesc.primaryETA = `${primaryHour} ${this.$t(
        'global.time.hours'
      )} ${primaryMinutes} ${this.$t('global.time.minutes')} ${primarySeconds} ${this.$t(
        'global.time.seconds'
      )}`
      const primaryLine = primaryGeofence?.data?.routes[0].geometry.coordinates.map(
        ([long, lat]) => ({ long, lat })
      )
      if (primaryMarker.length > 1) this.$root.$emit('polyLine', primaryLine, 0, primaryMarker)

      if (primaryGeofence?.data?.routes[0].duration) {
        this.routeDurations.primary = primaryGeofence.data.routes[0].duration
      }
      if (this.formValues.alternate) {
        const altMarker = await this.getRouteCoords('altgeofence')
        const altGeofence = await this.getDirection('altgeofence') //undefined
        if (altMarker.length > 2) this.altAlert = true
        //set alternative line
        const [altHour, altMinutes, altSeconds] = this.convertSectoHMS(
          altGeofence?.data?.routes[0].duration
        )
        this.routeDesc.alternateDistance = this.minimizeFloat(
          altGeofence?.data?.routes[0].distance / 1000
        )
        this.routeDesc.alternateETA = `${altHour} ${this.$t(
          'global.time.hours'
        )} ${altMinutes} ${this.$t('global.time.minutes')} ${altSeconds} ${this.$t(
          'global.time.seconds'
        )}`

        const altLine = altGeofence?.data?.routes[0].geometry.coordinates.map(([long, lat]) => ({
          long,
          lat,
        }))
        if (altMarker.length > 2) this.$root.$emit('polyLine', altLine, 1, altMarker)

        if (altGeofence?.data?.routes[0].duration) {
          this.routeDurations.alternate = altGeofence.data.routes[0].duration
        }
      }
    },
    showUpdateStatus(status) {
      this.updateStatus = status
      this.$bvModal.show('mc-modal-update')
    },
    async handleUpdateStatus() {
      const ids = [parseInt(this.showResponse?.id)]
      const input = { ids: ids, status: this.updateStatus }
      const updatedData = await routeApi.updateStatus(input)

      if (!updatedData) {
        this.$mcToast.error('Data gagal diubah')
      } else {
        if (updatedData.errors) {
          this.$mcToast.error(updatedData.errors)
        } else {
          this.$mcToast.success('Data berhasil diubah')
          this.track('Change Status Route')
        }
      }
      this.$refs['mc-modal-update'].hide()

      await this.showData()
    },
    handleRemove(keyPrefix) {
      if (keyPrefix == 'geofence') {
        const location = this.formValues.primary.map((item) => item.geofence)
        this.primaryObj = location.map((id) => this.optionsAddress.find((obj) => obj.id === id))
      } else {
        const location = this.formValues.alternate.map((item) => item.geofence)
        this.alternateObj = location.map((id) => this.optionsAddress.find((obj) => obj.id === id))
      }
    },
    async handleSubmit() {
      if (this.$refs.formRef.hasErrors) {
        this.$mcToast.error('Terdapat kesalahan format pada input anda')
        return
      }
      this.isSubmit = true
      const primaryGeofence = this.getRouteCoords('geofence')
      const altGeofence = this.getRouteCoords('altgeofence')
      const input = {
        name: this.formValues.name,
        route: [{ priority: 0, geofence: primaryGeofence }],
      }

      if (this.isAutoStart) {
        input.vehicle_ids = this.vehicleId.map((id) => Number(id)).filter((id) => id !== 0)
      }

      if (altGeofence.length > 2) {
        input.route.push({ priority: 1, geofence: altGeofence })
      }
      if (this.isAdding) {
        await this.submitStore(input)
      } else {
        await this.submitUpdate(this.routeId, input)
      }
    },
    async submitStore(data) {
      const createdData = await routeApi.store(data)
      if (createdData.status === 400) {
        let message = createdData.errors
        if (createdData.errors.includes('Vehicles not found')) {
          message = this.$t('global.alert.text.vehiclesNotFound')
        } else if (
          createdData.errors.includes(
            'Vehicles has been assigned on another route with the same origin waypoint'
          )
        ) {
          message = this.$t('global.alert.text.vehiclesHasAssigned')
        } else if (createdData.errors.includes('Vehicles has been scheduled in route planning')) {
          message = this.$t('global.alert.text.vehiclesHasScheduled')
        } else if (
          createdData.errors.includes(
            'There are vehicles from another vehicle group assigned to this route'
          )
        ) {
          message = this.$t('global.alert.text.vehiclesAntoherVgroup')
        }
        this.$mcToast.error(message)
        this.isSubmit = false
        return false
      }

      if (createdData.status === 409) {
        let message = createdData.errors
        if (createdData.errors.includes('Data Duplicate Error')) {
          message = this.$t('global.alert.text.duplicateData')
        }
        this.$mcToast.error(message)
        this.isSubmit = false
        return false
      }

      const refetchedData = await routeApi.show(createdData.data.route_id)
      if (!refetchedData) return false

      this.$mcToast.success('Data berhasil ditambahkan')

      this.track('Create Route')
      this.$router.push({ name: 'Master Route' })
    },
    async submitUpdate(id, data) {
      data['status'] = this.status
      const updatedData = await routeApi.update(id, data)
      if (updatedData.status === 400) {
        let message = updatedData.errors
        if (updatedData.errors.includes('Vehicles not found')) {
          message = this.$t('global.alert.text.vehiclesNotFound')
        } else if (
          updatedData.errors.includes(
            'Vehicles has been assigned on another route with the same origin waypoint'
          )
        ) {
          message = this.$t('global.alert.text.vehiclesHasAssigned')
        } else if (updatedData.errors.includes('Vehicles has been scheduled in route planning')) {
          message = this.$t('global.alert.text.vehiclesHasScheduled')
        } else if (
          updatedData.errors.includes(
            'There are vehicles from another vehicle group assigned to this route'
          )
        ) {
          message = this.$t('global.alert.text.vehiclesAntoherVgroup')
        }
        this.$mcToast.error(message)
        this.isSubmit = false
        return false
      }

      if (updatedData.status === 409) {
        let message = updatedData.errors
        if (updatedData.errors.includes('Data Duplicate Error')) {
          message = this.$t('global.alert.text.duplicateData')
        }
        this.$mcToast.error(message)
        this.isSubmit = false
        return false
      }

      const refetchedData = await routeApi.show(updatedData.data.route_id)
      if (!refetchedData) return false

      this.$mcToast.success('Data berhasil diubah')
      this.track('Change Route')
      this.$router.push({ name: 'Master Route' })
    },
    handleCancel() {
      this.$router.push({ name: 'Master Route' })
    },
    handleConfirmOriginLocation() {
      const originLocationId = Number(this.originLocation)
      const originLocation = this.optionsAddress.find((obj) => obj.id === originLocationId)
      if (this.primaryObj.length > 0) {
        this.primaryObj[0] = {
          id: originLocation.id,
          name: originLocation.name,
          type: originLocation.type,
          coordinates: originLocation.geolocation,
        }
      } else {
        this.primaryObj = [originLocation]
      }

      if (!this.formValues.primary) {
        this.formValues.primary = [{ geofence: originLocationId }]
      } else {
        this.$set(this.formValues.primary, 0, { geofence: originLocationId })
      }

      this.vehicleId = null
      this.$bvModal.hide('mc-modal-origin-location')
      this.setStart()
    },
    async getVehicle() {
      const res = await routeApi.getVehicle({ limit: 5, page: 1 })
      const total = res.metadata.total_count

      const vehicle = await routeApi.getVehicle({ limit: total, page: 1 })
      this.optionsVehicle = vehicle.data.paginated_result
    },
    updateTimeTranslations() {
      if (this.routeDurations.primary) {
        const [primaryHour, primaryMinutes, primarySeconds] = this.convertSectoHMS(
          this.routeDurations.primary
        )
        this.routeDesc.primaryETA = `${primaryHour} ${this.$t(
          'global.time.hours'
        )} ${primaryMinutes} ${this.$t('global.time.minutes')} ${primarySeconds} ${this.$t(
          'global.time.seconds'
        )}`
      }

      if (this.routeDurations.alternate) {
        const [altHour, altMinutes, altSeconds] = this.convertSectoHMS(
          this.routeDurations.alternate
        )
        this.routeDesc.alternateETA = `${altHour} ${this.$t(
          'global.time.hours'
        )} ${altMinutes} ${this.$t('global.time.minutes')} ${altSeconds} ${this.$t(
          'global.time.seconds'
        )}`
      }
    },
  },
}
</script>
